<template>
    <div>
      <div class="d-flex justify-content-between">
        <h1 class="page-header">{{ $t('receipt.pageTitle') }}</h1>
        <ts-breadcrumb
          :items="[
            { text: $t('toHomePage'), href: '/' },
            { text: $t('receipt.pageTitle'), href: '/' },
            {
              text: $t('create'),
              active: true,
            },
          ]"
        />
      </div>
      <ts-card>
        <ts-card-wrapper>
          <div class="d-flex justify-content-between">
            <a
              href="#"
              v-tooltip="$t('back')"
              @click.prevent="$router.push({ name: 'receipt' })"
            >
              <i class="fa fa-arrow-circle-left fa-2x"></i>
            </a>
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
          </div>
          <ts-loading-banner :loading="loading">
            <table id="list" class="table mt-3">
              <thead>
                <tr>
                  <th>{{ $t('receipt.invoiceNumber') }}</th>
                  <th>{{ $t('receipt.studentId') }}</th>
                  <th>{{ $t('receipt.studentName') }}</th>
                  <th>{{ $t('receipt.sex') }}</th>
                  <th>{{ $t('receipt.nextPaymentDate') }}</th>
                  <th>{{ $t('receipt.amount') }}</th>
                  <th>{{ $t('receipt.amountDue') }}</th>
                  <th style="width: 30px">{{ $t('actions') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(resource, index) in resources" :key="index">
                  <td>{{ resource.inv_number }}</td>
                  <td>{{ resource.card_number }}</td>
                  <td>{{ resource.full_name_en }}</td>
                  <td>{{ resource.gender }}</td>
                  <td>{{ resource.next_payment_date }}</td>
                  <td>{{ resource.inv_amount }}</td>
                  <td>{{ resource.amount_due }}</td>
                  <td class="text-center">
                    <a
                      href="#"
                      class="text-primary"
                      v-tooltip="$t('receipt.pay')"
                      @click.prevent="visitableModel(resource)"
                    >
                      <i class="fas fa-file-invoice-dollar"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </ts-loading-banner>
          <a-modal
            v-if="visible"
            v-model="visible"
            :title="$t('receipt.pay')"
            @cancel="cancelPayment"
            width="60%"
            :maskClosable="false"
            :confirmLoading="waiting"
            :footer="null"
            :zIndex="1020"
          >
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <form-component v-model="model" :validate="errors" :banks="banks">
                    <template v-slot:button-action>
                      <ts-button class="mr-2" @click.prevent="cancelPayment">{{
                        $t('cancel')
                      }}</ts-button>
                      <ts-button
                        :waiting="waiting"
                        color="primary"
                        @click.prevent="payReceipt"
                        >{{ $t('save') }}</ts-button
                      >
                    </template>
                  </form-component>
                </div>
              </div>
            </div>
						<div class="row">
							<div class="col-md-12">
								<div class="form-group">								
									<preview-pdf-component :src="src" :waiting="waiting" />									
								</div>
							</div>
						</div>
          </a-modal>
        </ts-card-wrapper>
      </ts-card>
    </div>
  </template>
  <script>
  import { mapActions } from 'vuex'
  import { debounce } from 'lodash'
  import { Errors } from 'form-backend-validation'
  import moment from 'moment'
  import { PreviewPdfComponent, FormComponent } from './components'
  
  export default {
    name: 'receiptCreate',
    components: {
      FormComponent,
      PreviewPdfComponent,
    },
    data() {
      return {
        waiting: false,
        loading: false,
        search: null,
        visible: false,
        src: null,
        resources: [],
        exchangeRate: [],
        banks: [],
        errors: new Errors(),
        model: {
          inv_id: null,
          invoice_number: null,
          inv_amount: null,
          amount_paid: null,
          amount_due: 0,
          payment_date: moment().format('DD-MM-YYYY'),
          next_payment_date: null,
          comment: null,
          bank_id: null,
          payment_type: 2,
          exchange_rate: null,
          payment_method_id: 1, // cash
        },
      }
    },
    created() {
      this.getInvoiceList()
      this.fetchExchangeRate()
      this.fetchBank()
    },
    methods: {
      ...mapActions('receiptModule', [
        'onGetInvoice',
        'onGetExchange',
        'onGetBank',
        'onSave'
      ]),
      getInvoiceList(attributes = {}) {
        this.loading = true
        this.onGetInvoice(attributes)
          .then((response) => {
            this.resources = response.data.data
          })
          .finally(() => {
            this.loading = false
          })
      },
      fetchBank() {
        this.onGetBank()
          .then((response) => {
            this.banks = response.data.data
          })
      },
      fetchExchangeRate() {
        this.loading = true
        this.onGetExchange()
          .then((response) => {
            this.exchangeRate = response.data.exchange_rate
          })
          .finally(() => {
            this.loading = false
          })
      },
      visitableModel(record) {
        this.errors = new Errors()
        this.visible = true
        this.model.inv_id = record.inv_id
        this.model.invoice_number = record.inv_number
        this.model.inv_amount = record.amount_due
        this.model.payment_date = moment().format('DD-MM-YYYY')
        this.model.exchange_rate = this.exchangeRate
        this.model.next_payment_date = null
        this.model.comment = null
      },
      payReceipt() {
        this.waiting = true
        this.onSave(this.model)
          .then((response) => {
            this.$toasted.success(response.message)
            this.clearInput()
            this.src = response.data.url
          })
          .catch((error) => {
            this.errors = new Errors(error.response.data.errors)
            this.$toasted.error(error.response.data.message)
          })
          .finally(() => {
            this.waiting = false
          })
      },
      cancelPayment() {
        this.visible = false
        this.clearInput()
        this.getInvoiceList()
      },
      clearInput() {
        ;(this.model.inv_id = null),
          (this.model.invoice_number = null),
          (this.model.inv_amount = null),
          (this.model.amount_paid_usd = null),
          (this.model.amount_paid_khr = null),
          (this.model.exchange_rate = null),
          (this.model.amount_due = 0),
          (this.model.payment_date = moment().format('DD-MM-YYYY')),
          (this.model.next_payment_date = null),
          (this.model.comment = null),
          (this.model.bank_id = null),
          (this.model.payment_type = 2)
        this.src = null
      },
    },
    watch: {
      search: debounce(function (search) {
        this.getInvoiceList({ search: search })
      }, 500),
    },
  }
  </script>
  
  <style lang="css" scoped>
  label {
    font-size: 12px !important;
  }
  #list > thead > tr > th {
    padding: 5px 4px;
    background: #f2f3f4;
    text-transform: uppercase;
  }
  #list > tbody > tr > td {
    padding: 5px 4px;
    border: none !important;
    font-size: 12px !important;
  }
  </style>
  